import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class SiteFooter extends Component {

    render() {
        return (
            <div className="page_contents">
                <div className="site-footer">
                    <ul className="site-footer-links pull-right">
                        <li>
                            <Link to="/privacy-policy">{'Privacy'}</Link>
                        </li>
                        <li>
                            <Link to="/terms-of-service">{'Terms'}</Link>
                        </li>
                        <li>
                            <Link to="/contacts">{'Contacts'}</Link>
                        </li>
                        <li>
                            <Link to="/about">{'About'}</Link>
                        </li>
                    </ul>
                    <ul className="site-footer-links">
                        <li>
                            {`Copyright \u00A9 2017 - ${new Date().getFullYear()} Deep Contrast, Inc.`}
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SiteFooter.js